import React from 'react';
import { Button as MuiButton } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledButton = styled(MuiButton)(({ variant, size }) => ({
  borderRadius: '8px',
  textTransform: 'none',
  fontWeight: 600,
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  boxShadow:
    variant === 'contained'
      ? '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)'
      : 'none',

  ...(size === 'large' && {
    height: '56px',
    padding: '16px 40px',
    fontSize: '16px',
    fontWeight: 600,
  }),

  ...(size === 'medium' && {
    height: '44px',
    padding: '10px 24px',
  }),

  ...(variant === 'contained' && {
    backgroundColor: '#D91A5B',
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#B71549',
      boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
    },
  }),

  ...(variant === 'outlined' && {
    border: '2px solid',
    borderColor: 'rgba(0, 0, 0, 0.1)',
    backgroundColor: 'rgba(0, 0, 0, 0.02)',
    color: '#121212',
    '&:hover': {
      backgroundColor: '#FFFFFF',
      borderColor: 'rgba(0, 0, 0, 0.2)',
    },
  }),

  ...(variant === 'text' && {
    border: '2px solid',
    borderColor: 'rgba(0, 0, 0, 0.1)',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    color: '#121212',
    '&:hover': {
      backgroundColor: '#FFFFFF',
      borderColor: 'rgba(0, 0, 0, 0.2)',
    },
  }),
}));

export default function Button({ children, variant = 'contained', size = 'medium', ...props }) {
  return (
    <StyledButton variant={variant} size={size} {...props}>
      {children}
    </StyledButton>
  );
}
